import { useSearchParams } from 'react-router-dom';

import SystemLoginRecords from '../Components/SectionsForActivityLogs/SystemLoginRecords';
import ImportantEvents from '../Components/SectionsForActivityLogs/ImportantEvents';

import HeadlinePanel from '../Components/HeadlinePanel';

import subpageSelection from '../styles/SubpageSelection.module.css';


export default function ActivityLogs() {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'important-events';

    return (
        <div className='mainContainer'>
            <HeadlinePanel label='Действия в системе' type='Назад' />
            <div className='containerInner'>
                <div className={subpageSelection.panel}>
                    <a onClick={() => setSearchParams({ section: 'important-events' })} className={`${subpageSelection.buttonToSubPages} ${section === 'important-events' ? subpageSelection.active : ''}`}>Журнал событий</a>
                    <a onClick={() => setSearchParams({ section: 'system-login-records' })} className={`${subpageSelection.buttonToSubPages} ${section === 'system-login-records' ? subpageSelection.active : ''}`}>Последние записи входа</a>
                </div>
                <div className='pageWrapper'>
                    {section == 'important-events' ? <ImportantEvents />
                    : section == 'system-login-records' ? <SystemLoginRecords />
                    : <a className='description'>Выберите вкладку</a>}
                </div>
            </div>
        </div>
    )
}
